/*
 *
 *   INSPINIA - Responsive Admin Theme
 *   version 2.8
 *
 */

$(document).ready(function () {

    // Fast fix bor position issue with Propper.js
    // Will be fixed in Bootstrap 4.1 - https://github.com/twbs/bootstrap/pull/24092
    Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;


    // Add body-small class if window less than 768px
    if ($(window).width() < 769) {
        $('body').addClass('body-small')
    } else {
        $('body').removeClass('body-small')
    }

    // MetisMenu
    var sideMenu = $('#side-menu').metisMenu();

    sideMenu.on('shown.metisMenu', function (e) {
        fix_height();
    });

    // Collapse ibox function
    $('.collapse-link').on('click', function (e) {
        e.preventDefault();
        var ibox = $(this).closest('div.ibox');
        var button = $(this).find('i');
        var content = ibox.children('.ibox-content');
        content.slideToggle(200);
        button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        ibox.toggleClass('').toggleClass('border-bottom');
        setTimeout(function () {
            ibox.resize();
            ibox.find('[id^=map-]').resize();
        }, 50);
    });

    // Close ibox function
    $('.close-link').on('click', function (e) {
        e.preventDefault();
        var content = $(this).closest('div.ibox');
        content.remove();
    });

    // Fullscreen ibox function
    $('.fullscreen-link').on('click', function (e) {
        e.preventDefault();
        var ibox = $(this).closest('div.ibox');
        var button = $(this).find('i');
        $('body').toggleClass('fullscreen-ibox-mode');
        button.toggleClass('fa-expand').toggleClass('fa-compress');
        ibox.toggleClass('fullscreen');
        setTimeout(function () {
            $(window).trigger('resize');
        }, 100);
    });

    // Close menu in canvas mode
    $('.close-canvas-menu').on('click', function (e) {
        e.preventDefault();
        $("body").toggleClass("mini-navbar");
        SmoothlyMenu();
    });

    // Run menu of canvas
    $('body.canvas-menu .sidebar-collapse').slimScroll({
        height: '100%',
        railOpacity: 0.9
    });

    // Open close right sidebar
    $('.right-sidebar-toggle').on('click', function (e) {
        e.preventDefault();
        $('#right-sidebar').toggleClass('sidebar-open');
    });

    // Initialize slimscroll for right sidebar
    $('.sidebar-container').slimScroll({
        height: '100%',
        railOpacity: 0.4,
        wheelStep: 10
    });

    // Open close small chat
    $('.open-small-chat').on('click', function (e) {
        e.preventDefault();
        $(this).children().toggleClass('fa-comments').toggleClass('fa-times');
        $('.small-chat-box').toggleClass('active');
    });

    // Initialize slimscroll for small chat
    $('.small-chat-box .content').slimScroll({
        height: '234px',
        railOpacity: 0.4
    });

    // Small todo handler
    $('.check-link').on('click', function () {
        var button = $(this).find('i');
        var label = $(this).next('span');
        button.toggleClass('fa-check-square').toggleClass('fa-square-o');
        label.toggleClass('todo-completed');
        return false;
    });

    // Append config box / Only for demo purpose
    // Uncomment on server mode to enable XHR calls
    //$.get("skin-config.html", function (data) {
    //    if (!$('body').hasClass('no-skin-config'))
    //        $('body').append(data);
    //});

    // Minimalize menu
    $('.navbar-minimalize').on('click', function (event) {
        event.preventDefault();
        $("body").toggleClass("mini-navbar");
        SmoothlyMenu();

    });

    // Tooltips demo
    $('.tooltip-demo').tooltip({
        selector: "[data-toggle=tooltip]",
        container: "body"
    });


    // Move right sidebar top after scroll
    $(window).scroll(function () {
        if ($(window).scrollTop() > 0 && !$('body').hasClass('fixed-nav')) {
            $('#right-sidebar').addClass('sidebar-top');
        } else {
            $('#right-sidebar').removeClass('sidebar-top');
        }
    });

    $("[data-toggle=popover]")
        .popover();

    // Add slimscroll to element
    $('.full-height-scroll').slimscroll({
        height: '100%'
    })
});



// Fixed Sidebar
$(window).bind("load", function () {
    if ($("body").hasClass('fixed-sidebar')) {
        $('.sidebar-collapse').slimScroll({
            height: '100%',
            railOpacity: 0.9
        });
    }
});

function fix_height() {
    var heightWithoutNavbar = $("body > #wrapper").height() - 62;
    $(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarheight = $('nav.navbar-default').height();
    var wrapperHeight = $('#page-wrapper').height();

    if (navbarheight > wrapperHeight) {
        $('#page-wrapper').css("min-height", navbarheight + "px");
    }

    if (navbarheight < wrapperHeight) {
        $('#page-wrapper').css("min-height", $(window).height() + "px");
    }

    if ($('body').hasClass('fixed-nav')) {
        if (navbarheight > wrapperHeight) {
            $('#page-wrapper').css("min-height", navbarheight + "px");
        } else {
            $('#page-wrapper').css("min-height", $(window).height() - 60 + "px");
        }
    }

}

$(window).bind("load resize scroll", function () {

    // Full height of sidebar
    setTimeout(function(){
        if (!$("body").hasClass('body-small')) {
            fix_height();
        }
    })

});

// Minimalize menu when screen is less than 768px
$(window).bind("resize", function () {
    if ($(this).width() < 769) {
        $('body').addClass('body-small')
    } else {
        $('body').removeClass('body-small')
    }
});

// Local Storage functions
// Set proper body class and plugins based on user configuration
$(document).ready(function () {
    if (localStorageSupport()) {

        var collapse = localStorage.getItem("collapse_menu");
        var fixedsidebar = localStorage.getItem("fixedsidebar");
        var fixednavbar = localStorage.getItem("fixednavbar");
        var boxedlayout = localStorage.getItem("boxedlayout");
        var fixedfooter = localStorage.getItem("fixedfooter");

        var body = $('body');

        if (fixedsidebar == 'on') {
            body.addClass('fixed-sidebar');
            $('.sidebar-collapse').slimScroll({
                height: '100%',
                railOpacity: 0.9
            });
        }

        if (collapse == 'on') {
            if (body.hasClass('fixed-sidebar')) {
                if (!body.hasClass('body-small')) {
                    body.addClass('mini-navbar');
                }
            } else {
                if (!body.hasClass('body-small')) {
                    body.addClass('mini-navbar');
                }

            }
        }

        if (fixednavbar == 'on') {
            $(".navbar-static-top").removeClass('navbar-static-top').addClass('navbar-fixed-top');
            body.addClass('fixed-nav');
        }

        if (boxedlayout == 'on') {
            body.addClass('boxed-layout');
        }

        if (fixedfooter == 'on') {
            $(".footer").addClass('fixed');
        }
    }
});

// check if browser support HTML5 local storage
function localStorageSupport() {
    return (('localStorage' in window) && window['localStorage'] !== null)
}

// For demo purpose - animation css script
function animationHover(element, animation) {
    element = $(element);
    element.hover(
        function () {
            element.addClass('animated ' + animation);
        },
        function () {
            //wait for animation to finish before removing classes
            window.setTimeout(function () {
                element.removeClass('animated ' + animation);
            }, 2000);
        });
}

function SmoothlyMenu() {
    if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
        // Hide menu in order to smoothly turn on when maximize menu
        $('#side-menu').hide();
        // For smoothly turn on menu
        setTimeout(
            function () {
                $('#side-menu').fadeIn(400);
            }, 200);
    } else if ($('body').hasClass('fixed-sidebar')) {
        $('#side-menu').hide();
        setTimeout(
            function () {
                $('#side-menu').fadeIn(400);
            }, 100);
    } else {
        // Remove all inline style from jquery fadeIn function to reset menu state
        $('#side-menu').removeAttr('style');
    }
}

// Dragable panels
function WinMove() {
    var element = "[class*=col]";
    var handle = ".ibox-title";
    var connect = "[class*=col]";
    $(element).sortable(
        {
            handle: handle,
            connectWith: connect,
            tolerance: 'pointer',
            forcePlaceholderSize: true,
            opacity: 0.8
        })
        .disableSelection();
}

// Control por medio del teclado
/*
* Snippet para detectar una pulsacion de tecla
*/
function setKeyPress() {
    
    var current = window.location.pathname;
    current = current.split('/');
    if (current[1] != 'admin' && current[1] != 'registro' && current[1] != 'pictionary' && current[1] != 'crucigrama' && current[1] != 'quizz' ) {
        document.onkeydown = function(evt) {
            evt = evt || window.event;
            list_of_actions(evt.key)
        };
    }
}

function list_of_actions(letter_press) {
    switch (letter_press) {
        case "s":
        case "S":
            console.log("Siguiente")
            getNextPage()
            break;
        case "a":
        case "A":
            console.log("Anterior")
            break;
        case "c":
        case "C":
            console.log("Iniciar/Continuar cronometro")
            start_chrono()
            break;
        case "x":
        case "X":
            console.log("Parar cronometro")
            stop_chrono()
            break;
        case "v":
        case "V":
            console.log("Reiniciar cronometro")
            reset_chrono()
            break;
        case "p":
        case "P":
            console.log("Mostrar pregunta")
            break;
        case "o":
        case "O":
            console.log("Ocultar pregunta")
            break;
        case "r":
        case "R":
            console.log("Mostrar respuesta")
            show_correct_answer()
            break;
        case "e":
        case "E":
            console.log("Ocultar respuesta")
            hide_correct_answer()
            break;
        case "t":
        case "T":
            console.log("Ocultar pregunta y mostrar pregunta")
            break;
        case "m":
        case "M":
            console.log("Palpito Activo")
            active_palpito()
            break;
        case "n":
        case "n":
            console.log("Palpito desactivado")
            desactive_palpito()
            break;
        case ".":
            console.log("Crucigrama Activo")
            active_miniprueba_crucigrama()
            break;
        case ",":
            console.log("Crucigrama desactivado")
            desactive_miniprueba_crucigrama()
            break;
        case "k":
        case "K":
            console.log("Extra-life Activo")
            active_extralife()
            break;
        case "l":
        case "L":
            console.log("Extra-life desactivado")
            desactive_extralife()
            break;
    
        default:
            console.log("Accion no reconocida??")
            break;
    }
}
//setKeyPress()

/**
 * Funcion para obtener la url actual y determinar cual el la siguiente url
 */
function getNextPage() {
    var current = window.location.pathname;
    current = current.split('/');
    console.log(current);
    //console.log(list_of_steps(current[1]));
    //window.location.href = "/"+list_of_steps(current[1])+"/"+current[2]
    window.location.replace("/"+list_of_steps(current[1])+"/"+current[2])
}

class StepPage{
    constructor(prev, current, next){
        this.prev = prev
        this.current = current
        this.next = next
    }
}
var list_steps = [];
function list_of_steps_obj(current_position) {
    // Espera
    list_steps.push(new StepPage("main", "main", "instrucciones"))
    list_steps.push(new StepPage("main", "instrucciones", "espera"))
    list_steps.push(new StepPage("instrucciones", "espera", "pregunta"))

    // pregunta 1
    list_steps.push(new StepPage("espera", "pregunta", "explicacion"))
    list_steps.push(new StepPage("pregunta", "explicacion", "ranking"))
    list_steps.push(new StepPage("explicacion", "ranking", "circuito"))
    list_steps.push(new StepPage("ranking", "circuito", "espera"))
    list_steps.push(new StepPage("circuito", "espera", "pregunta"))

    // pregunta 2
    list_steps.push(new StepPage("espera", "pregunta", "explicacion"))
    list_steps.push(new StepPage("pregunta", "explicacion", "ranking"))
    list_steps.push(new StepPage("explicacion", "ranking", "circuito"))
    list_steps.push(new StepPage("ranking", "circuito", "espera"))
    list_steps.push(new StepPage("circuito", "espera", "pregunta"))

    // pregunta 3
    list_steps.push(new StepPage("espera", "pregunta", "explicacion"))
    list_steps.push(new StepPage("pregunta", "explicacion", "ranking"))
    list_steps.push(new StepPage("explicacion", "ranking", "circuito"))
    list_steps.push(new StepPage("ranking", "circuito", "espera"))
    list_steps.push(new StepPage("circuito", "espera", "crucigrama-espera"))

    // crucigrama 1
    list_steps.push(new StepPage("espera", "crucigrama-espera", "crucigrama-explicacion"))
    list_steps.push(new StepPage("crucigrama-espera", "crucigrama-explicacion", "crucigrama-palabras"))
    list_steps.push(new StepPage("crucigrama-explicacion", "crucigrama-palabras", "crucigrama-solucion"))
    list_steps.push(new StepPage("crucigrama-palabras", "crucigrama-solucion", "crucigrama-ranking"))
    list_steps.push(new StepPage("crucigrama-solucion", "crucigrama-ranking", "palpito-espera"))

    // palpito 1
    list_steps.push(new StepPage("", "palpito-espera", "palpito"))
    list_steps.push(new StepPage("", "palpito", "palpito-ranking"))
    list_steps.push(new StepPage("", "palpito-ranking", ""))

    var l = {
        'pregunta-1': {page: "pregunta", next: "pregunta-2"},
        'pregunta-2': {page: "pregunta", next: "pregunta-3-especial"},
        'pregunta-3-especial': {page: "pregunta", next: "miniprueba-1"},
        'miniprueba-1': {page: "crucigrama-espera", next: "palpito-1"},
        'palpito-1': {page: "palpito-espera", next: "palpito-1"},
        'pregunta-4': {page: "pregunta", next: "pregunta-5"},
        'pregunta-5': {page: "pregunta", next: "pregunta-6"},
        'pregunta-6': {page: "pregunta", next: "miniprueba-2-ahorcado"},
        'miniprueba-2-ahorcado': "",
        'palpito-2': "",
        'pregunta-7': "",
        'pregunta-8': "",
        'miniprueba-2-ahorcado': "",
        'palpito-3': "",
        'pregunta-9-especial': "",
        'determinar-ganador': "",
        'pregunta-desempate': "",
        'ganador': ""
    }
}

window.active_miniprueba_ahorcado = false;
/**
 * Devuelve la siguiente página con respecto a la página dada
 * @param {string} current_position Url de nuestra actual página
 * @returns String de la siguiente página  
 */
function list_of_steps(current_position) {


    switch (current_position) {
        case 'main':
            return 'instrucciones';
        case 'instrucciones':
            return 'espera';
        case 'espera':
            return 'pregunta-espera';
        case 'pregunta-espera':
            return 'pregunta';
        case 'pregunta':
            return 'explicacion';
        case 'explicacion':
            if (get_state_palpito() == 'true') {
                desactive_palpito()
                increase_palpito()
                return 'palpito-espera-'+get_palpito_value()
            }
            return 'ranking';
        case 'ranking':
            return 'circuito';
        case 'circuito':
            return 'ranking';
            // Determina si mostrar el camino del palpito
            // if (get_state_palpito() == 'true') {
            //     desactive_palpito()
            //     increase_palpito()
            //     return 'palpito-espera-'+get_palpito_value()
            // }

            // // Determina si mostrar el camino de crucigrama
            // if(get_state_crucigrama() == 'true'){
            //     desactive_miniprueba_crucigrama()
            //     return 'crucigrama-espera';
            // }

            // // Determina si mostrar la pantalla de espera de Extra Life
            // if (get_State_extralife() == 'true') {
            //     desactive_extralife()
            //     return 'pregunta-extra-life-espera';
            // }


        case 'palpito-espera-1':
            return 'palpito-1';
        case 'palpito-1':
            return 'ranking';
        case 'palpito-espera-2':
            return 'palpito-2';
        case 'palpito-2':
            //return 'ranking';
            return 'crucigrama-espera';
        case 'palpito-espera-3':
            return 'palpito-3';
        case 'palpito-3':
            return 'ranking';

        case 'crucigrama-espera':
            return 'crucigrama-explicacion';
        case 'crucigrama-explicacion':
            return 'crucigrama-palabras';
        case 'crucigrama-palabras':
            return 'crucigrama-solucion';
        case 'crucigrama-solucion':
            return 'crucigrama-ranking';

        case 'pregunta-extra-life-espera':
            return 'pregunta-extra-life';
        case 'pregunta-extra-life':
            return 'pregunta-extra-life-explicacion';
        case 'pregunta-extra-life-explicacion':
            return 'ranking';

        default:
            return current_position;
    }
}

/* Cronometro - CircleProgress */
var chrono = undefined;
/* Temporizador del cronomtro*/
var chrono_timer = undefined;
/* Valor maximo - parametro 'GLOBAL' */
window.chrono_max_value = 45;

/**
 * Detecta el identificador del cronometro e inicia un circulo de progreso
 */
function detect_chrono() {
    var chrono_place = document.getElementById('chrono-zero')

    if (chrono_place) {
        chrono = new CircleProgress('#chrono-zero',{
            max: window.chrono_max_value,
            value: 0,
            textFormat: 'value'
        })
    }
}
detect_chrono()

function start_chrono() {
    if (chrono) {
        chrono.max = window.chrono_max_value
        stop_chrono()
        chrono_timer = setInterval(() => {
            chrono.value += 1;
        }, 1000);
    }
}

function stop_chrono() {
    clearInterval(chrono_timer);
}

function reset_chrono() {
    stop_chrono()
    if (chrono) {
        chrono.value = 0
    }
}

/**
 * Aplica una animación de latido, para la respuesta correcta y atenua la respuesta incorrecta
 */
function show_correct_answer() {
    if (document.getElementById('correct')) {
        document.getElementById('correct').classList.add('heart');
        document.querySelectorAll('[id^="incorrect-"]').forEach(element =>{
            element.classList.add('incorrect');
        });
    }
}
/**
 * Oculta la respuesta correcta e incorrecta
 */
function hide_correct_answer() {
    if (document.getElementById('correct')) {
        document.getElementById('correct').classList.remove('heart');
        document.querySelectorAll('[id^="incorrect-"]').forEach(element =>{
            element.classList.remove('incorrect');
        });
    }
}

/* Controles de palpito */
function active_palpito() {
    var key_active_palpito = 'key_active_palpito'
    localStorage.setItem(key_active_palpito, 'true')
}

function desactive_palpito() {
    var key_active_palpito = 'key_active_palpito'
    localStorage.setItem(key_active_palpito, 'false')
}

function get_state_palpito() {
    var key_active_palpito = 'key_active_palpito'
    var palpito_state = localStorage.getItem(key_active_palpito)
    return palpito_state
}
/**
 * Incrementa el contador del palpito
 */
function increase_palpito() {
    var key_palpito = 'palpito_position'
    var palpito_position = localStorage.getItem(key_palpito)
    if (!palpito_position) {
        palpito_position = 0
    }
    palpito_position = parseInt(palpito_position, 10) + 1
    localStorage.setItem(key_palpito, palpito_position)
}

window.increase_palpito = increase_palpito

/**
 * Obtiene el numero del palpito a mostrar
 */
function get_palpito_value() {
    var key_palpito = 'palpito_position'
    var palpito_position = localStorage.getItem(key_palpito)
    if (palpito_position == undefined) {
        localStorage.setItem(key_palpito, 0)
        palpito_position = 0
    }
    return palpito_position
}
window.get_palpito_value = get_palpito_value

/* Controles de crucigrama */
/**
 * Activa el crucigrama y guarda un valor en el localstorage
 */
function active_miniprueba_crucigrama() {
    var key_mp_crucigrama = 'active_miniprueba_crucigrama'
    localStorage.setItem(key_mp_crucigrama, 'true')
}
/**
 * Desactiva el crucigrama y guarda un valor en el localstorage
 */
function desactive_miniprueba_crucigrama() {
    var key_mp_crucigrama = 'active_miniprueba_crucigrama'
    localStorage.setItem(key_mp_crucigrama, 'false')
}
/**
 * Obtiene el estado del crucigrama dentro del localstorage
 */
function get_state_crucigrama() {
    var key_mp_crucigrama = 'active_miniprueba_crucigrama'
    var crucigrama_state = localStorage.getItem(key_mp_crucigrama)
    if (crucigrama_state == undefined) {
        localStorage.setItem(key_mp_crucigrama, 'false')
        crucigrama_state = 'false'
    }
    return crucigrama_state
}

/* Logica para mostrar la pantalla de extra-life */
function active_extralife() {
    var key_extralife = 'extra_life'
    localStorage.setItem(key_extralife, 'true')
}
function desactive_extralife() {
    var key_extralife = 'extra_life'
    localStorage.setItem(key_extralife, 'false')
}

function get_State_extralife() {
    var key_extralife = 'extra_life'
    var state = localStorage.getItem(key_extralife)
    if (state == undefined) {
        localStorage.setItem(key_extralife, 'false')
        state = 'false'
    }
    return state
}